import {
  EuiFlexGroup,
  EuiIcon,
  EuiSuperSelect,
  EuiSuperSelectOption,
} from "@inscopix/ideas-eui";
import { useDataTableContext } from "pages/gdt/store/DataTableProvider";

interface FieldTableCompressedProps {
  readOnly?: boolean;
  noItemsMessage?: string;
  isTableSelectable: (id: string) => boolean;
  value: string | undefined;
  onChange: (value: string | undefined) => void;
  disabled?: boolean;
}

export const FieldTableCompressed = ({
  readOnly = false,
  noItemsMessage = "No tables found",
  isTableSelectable,
  value,
  onChange,
  disabled = false,
}: FieldTableCompressedProps) => {
  const tables = useDataTableContext((s) => {
    return s.tables.filter(({ id }) => isTableSelectable(id));
  });

  // Disabled option displayed when tables exist
  const noItemsOption = {
    value: "no_items",
    disabled: true,
    inputDisplay: noItemsMessage,
  };

  const options: EuiSuperSelectOption<string>[] = tables.map((table) => ({
    value: table.id,
    inputDisplay: (
      <EuiFlexGroup
        alignItems="center"
        gutterSize="s"
        responsive={false}
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        <EuiIcon
          size="s"
          type={
            table.kind === "analysis" ? "indexMapping" : "tableDensityNormal"
          }
        />
        <span>
          {table.name} ({table.key})
        </span>
      </EuiFlexGroup>
    ),
  }));

  const handleChange = (newTableId: string) => {
    if (value === newTableId) {
      onChange(undefined);
    } else {
      onChange(newTableId);
    }
  };

  // Render the input display for the select option when in read-only mode
  if (readOnly) {
    const selectedOption = options.find((option) => option.value === value);
    return <>{selectedOption?.inputDisplay ?? null}</>;
  }

  return (
    <EuiSuperSelect
      popoverProps={{ style: { width: "100%" } }}
      compressed
      fullWidth
      options={options.length > 0 ? options : [noItemsOption]}
      valueOfSelected={value}
      onChange={handleChange}
      placeholder="None"
      disabled={disabled}
    />
  );
};
